import { PendingType } from './type';

export const findPendingOperation = (state: PendingType[], ...actionsToCheck: string[]): boolean =>
    state.some((action) => actionsToCheck.includes(action.type));

export const findPendingOperationWithId = (state: PendingType[], ...actionsToCheck: string[]): PendingType[] =>
    state.filter((action) => actionsToCheck.includes(action.type));
